import { render, staticRenderFns } from "./ShareCourseVideoDialog.vue?vue&type=template&id=ddf92c64&scoped=true"
import script from "./ShareCourseVideoDialog.vue?vue&type=script&lang=js"
export * from "./ShareCourseVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf92c64",
  null
  
)

export default component.exports